(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    (() => {
    const transitions = new WeakMap();
    const animateRow = (details, expand) => {
      const summary = details.querySelector(':scope > summary');
      if (!summary) return;
      const previous = transitions.get(details);
      const from = details.getBoundingClientRect().height;
      if (previous) previous.animation.cancel();
      transitions.delete(details);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        details.removeAttribute('data-yda-animating');
        details.removeAttribute('data-yda-closing');
        details.open = expand;
        return;
      }

      details.toggleAttribute('data-yda-closing', !expand);
      details.open = true;
      details.setAttribute('data-yda-animating', '');
      const style = getComputedStyle(details);
      const closedHeight = summary.getBoundingClientRect().height +
        parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth) +
        parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
      const to = expand ? details.getBoundingClientRect().height : closedHeight;
      const animation = details.animate(
        [{ height: `${from}px` }, { height: `${to}px` }],
        { duration: 700, easing: 'cubic-bezier(.075, .82, .165, 1)', fill: 'both' }
      );
      const transition = { animation, expand };
      transitions.set(details, transition);
      animation.onfinish = () => {
        if (transitions.get(details) !== transition) return;
        details.open = expand;
        details.removeAttribute('data-yda-animating');
        details.removeAttribute('data-yda-closing');
        transitions.delete(details);
        animation.cancel();
      };
    };
    const closeOtherRows = (details) => {
      details.closest('.accordion').querySelectorAll('.details').forEach((other) => {
        if (other === details) return;
        const state = transitions.get(other);
        if (state ? state.expand : other.open) animateRow(other, false);
      });
    };
    // Delegation also covers sections and rows re-rendered in the theme editor.
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const summary = event.target.closest('.product-details .accordion .details > summary');
      if (!summary || event.defaultPrevented) return;
      const details = summary.parentElement;
      if (!(details instanceof HTMLDetailsElement)) return;
      event.preventDefault();
      const previous = transitions.get(details);
      const expand = !(previous ? previous.expand : details.open);
      if (expand) closeOtherRows(details);
      animateRow(details, expand);
    }, true);
    // Honor exclusivity when the editor or native breakpoint logic opens a row too.
    document.addEventListener('toggle', (event) => {
      const details = event.target;
      if (details instanceof HTMLDetailsElement && details.matches('.product-details .accordion .details') &&
          details.open && !transitions.has(details)) closeOtherRows(details);
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["yumi-stock-shipping"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yumi-country-flag')) {
    let detectedCountry;

    const getDetectedCountry = () => {
      if (!detectedCountry) {
        const root = window.Shopify?.routes?.root || '/';
        detectedCountry = fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', {
          credentials: 'same-origin',
          signal: AbortSignal.timeout(4000)
        })
          .then((response) => {
            if (!response.ok) return null;
            return response.json();
          })
          .then((context) => {
            const code = context?.detected_values?.country?.handle;
            return typeof code === 'string' && /^[A-Z]{2}$/.test(code) ? code : null;
          })
          .catch(() => null);
      }
      return detectedCountry;
    };

    customElements.define('yumi-country-flag', class extends HTMLElement {
      static get observedAttributes() {
        return ['data-country'];
      }

      connectedCallback() {
        this.update();
      }

      attributeChangedCallback() {
        this.update();
      }

      update() {
        if (!this.isConnected) return;
        getDetectedCountry().then((code) => {
          if (!this.isConnected || !code || code === this.dataset.country) return;
          const image = this.querySelector('img');
          if (!image) return;

          const url = new URL(image.currentSrc || image.src);
          url.pathname = url.pathname.replace(/\/flags\/[a-z]{2}\.svg$/, '/flags/' + code.toLowerCase() + '.svg');
          const flag = new Image();
          flag.onload = () => {
            if (!this.isConnected || !this.contains(image)) return;
            image.removeAttribute('srcset');
            image.src = url.href;
            this.dataset.country = code;
          };
          flag.src = url.href;
        });
      }
    });
  }

  if (!customElements.get('yumi-delivery-estimate')) {
    customElements.define('yumi-delivery-estimate', class extends HTMLElement {
      connectedCallback() {
        this.update();
        this.visibilityHandler = () => {
          if (!document.hidden) this.update();
        };
        document.addEventListener('visibilitychange', this.visibilityHandler);
      }

      disconnectedCallback() {
        document.removeEventListener('visibilitychange', this.visibilityHandler);
      }

      update() {
        const minimum = Number(this.dataset.minDays);
        const maximum = Number(this.dataset.maxDays);
        const processingHours = Number(this.dataset.processingHours);
        if (![minimum, maximum, processingHours].every(Number.isFinite) ||
            minimum < 0 || maximum < minimum || processingHours < 0) return;

        const dispatch = new Date(Date.now() + processingHours * 60 * 60 * 1000);
        const originParts = new Intl.DateTimeFormat('en-GB', {
          timeZone: this.dataset.originTimeZone || 'Europe/Paris',
          year: 'numeric', month: '2-digit', day: '2-digit'
        }).formatToParts(dispatch);
        const part = (type) => Number(originParts.find((value) => value.type === type)?.value);
        const start = new Date(Date.UTC(part('year'), part('month') - 1, part('day'), 12));
        const earliest = new Date(start);
        const latest = new Date(start);
        earliest.setUTCDate(earliest.getUTCDate() + minimum);
        latest.setUTCDate(latest.getUTCDate() + maximum);
        const locale = this.dataset.locale || 'en';
        let format;
        try {
          format = new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric', timeZone: 'UTC' });
        } catch {
          format = new Intl.DateTimeFormat('en', { month: 'short', day: 'numeric', timeZone: 'UTC' });
        }
        this.dataset.earliestDate = earliest.toISOString().slice(0, 10);
        this.dataset.latestDate = latest.toISOString().slice(0, 10);
        this.textContent = format.format(earliest) + ' - ' + format.format(latest);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
